import { CLEAR_ONBOARDING, SET_GUIDE_VISIBLE, SET_IS_DRAG, SET_ONBOARDING_INITIAL_DATA, SET_ONBOARING_APP_DETAILS, SET_SERVICE_TASK_EXIST, SET_STAGE_INDEX, SET_STEPS, SET_STEP_INDEX } from "./types"

export const setGuideVisible = (data: any) => {
    return {
        type: SET_GUIDE_VISIBLE,
        payload: data
    }
}
export const setStepIndex = (data: any) => {
    return {
        type: SET_STEP_INDEX,
        payload: data
    }
}
export const setSteps = (data: any) => {
    return {
        type: SET_STEPS,
        payload: data
    }
}
export const setStageIndex = (data: any) => {
    return {
        type: SET_STAGE_INDEX,
        payload: data
    }
}
export const setInitialOnboarding = (data: any) => {
    return {
        type: SET_ONBOARDING_INITIAL_DATA,
        payload: data
    }
}
export const setOnboardingAppDetails = (data: any) => {
    return {
        type: SET_ONBOARING_APP_DETAILS,
        payload: data
    }
}
export const setIsDrag = (data: any) => {
    return {
        type: SET_IS_DRAG,
        payload: data
    }
}
export const clearOnboarding = (data: any) => {
    return {
        type: CLEAR_ONBOARDING,
        payload: data
    }
}
export const setServiceTaskExist = (data: any) => {
    return {
        type: SET_SERVICE_TASK_EXIST,
        payload: data
    }
}